module.exports = __webpack_public_path__ + "img/ms_success.b3528ed2.png";